import React from 'react';
import { useNavigate } from 'react-router-dom';

export const Footer = React.memo(() => {
  const navigate = useNavigate();

  return (
    <footer className="bg-white border-t border-gray-200 py-3 sm:py-4 mt-4 sm:mt-6" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-3 sm:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-0 sm:space-x-4 md:space-x-8 text-xs sm:text-sm text-gray-600">
          <span className="text-[11px] text-gray-400" data-testid="footer-copyright">&copy; 2025 ElonPrompt AI</span>
          <div className="flex items-center gap-3 sm:gap-4 md:gap-6">
            <button onClick={() => navigate('/about')} className="hover:text-[#BF5743] hover:underline transition-colors" data-testid="footer-about-link">About</button>
            <button onClick={() => navigate('/tutorial')} className="hover:text-[#BF5743] hover:underline transition-colors whitespace-nowrap">How-To</button>
            <button onClick={() => navigate('/contact')} className="hover:text-[#BF5743] hover:underline transition-colors">Contact</button>
            <button onClick={() => navigate('/privacy')} className="hover:text-[#BF5743] hover:underline transition-colors">Privacy</button>
            <button onClick={() => navigate('/terms')} className="hover:text-[#BF5743] hover:underline transition-colors">Terms</button>
          </div>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
